import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { getCurrentUser } from 'src/app/authentication/state/authentication.selector';
import { ConfirmationDialogService } from 'src/app/common-components/confirmation-dialog/confirmation-dialog.service';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { UserDetailSaveModel } from '../../user-details/models/user-detail-save.model';
import { AddUserApiService } from '../services/add-user-api.service';
import * as AddUserActions from './add-user.actions';

@Injectable()
export class AddUserEffects {
   createUser$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(AddUserActions.createUser),
         withLatestFrom(this.store.select(getSelectedAccountId), this.store.select(getCurrentUser)),
         switchMap(([action, accountId, currentUser]) => {
            const userToSave: UserDetailSaveModel = {
               ...action.user,
               accountId: currentUser?.isSystemUser ? action.user.accountId : accountId,
               isActive: true,
               isPasswordMigrated: true,
            };
            return this.addUserApiService.create(userToSave).pipe(
               map((executionResult) => {
                  return AddUserActions.createUserSuccess({
                     userId: executionResult.data.user.userId,
                     userName: executionResult.data.user.name,
                  });
               }),
               catchError((error) => {
                  return of(AddUserActions.createUserFailure(error));
               })
            );
         })
      );
   });

   createUserSuccess$ = createEffect(
      () => {
         return this.actions$.pipe(
            ofType(AddUserActions.createUserSuccess),
            tap((result) => {
               this.dialogService.closeFormComponent();
               this.router.navigate([`/${this.router.url}/${result.userId}`]);
               this.snackbar.open(`User ${result.userName} Created`);
            })
         );
      },
      {
         dispatch: false,
      }
   );

   constructor(
      private actions$: Actions,
      private addUserApiService: AddUserApiService,
      private store: Store,
      private snackbar: MatSnackBar,
      private dialogService: LcsDialogService,
      private confirmationService: ConfirmationDialogService,
      private router: Router
   ) {}
}
